import React from "react";
import {
    ValidationForm,
    Grid,
    Cell,
} from '@saladbob/sassafras'

import provinces from "../../data/provinces";
import { Country, Select, Text } from "./Fields";
import { User } from "../../types";

type Props = {
    user: User;
    onSubmit: Function;
    children?: React.ReactNode;
    formRef? : React.RefObject<React.Component>
};

const columns = {
    phone: "span 4",
    laptop: "span 2",
};

const UserContact: React.FC<Props> = ({ user, children, onSubmit, formRef: ref }) => {
    return (
        <ValidationForm ref={ref} onSubmit={onSubmit}>
            <Grid bgColor="white" columns="1fr 1fr 1fr 1fr" gridGap={{ phone: 'sm', laptop: 'lg' }} mb="md">
                <Cell column="span 4">
                    <Text
                        value={user.phone}
                        type="tel"
                        label="Phone"
                        name="phone"
                        rules={{
                            phone: true,
                            required: true,
                            minlength: 10,
                            maxlength: 10, 
                        }}
                    />
                </Cell>
                <Cell column={columns}>
                    <Text
                        value={user.address1}
                        label="Address"
                        name="address1"
                        rules={{
                            required: true,
                            minlength: 3,
                        }}
                    />
                </Cell>
                <Cell column={columns}>
                    <Text
                        value={user.address2}
                        label="Address 2"
                        name="address2"
                    />
                </Cell>
                <Cell column={columns}>
                    <Text
                        value={user.city}
                        label="City"
                        name="city"
                        rules={{ 
                            required: true,
                            minlength: 3,
                        }}
                    />
                </Cell>
                <Cell column={{ phone: 'span 2', laptop: 'span 1' }}>
                    <Select
                        placeholder="Select"
                        value={user.state}
                        options={provinces}
                        label="State"
                        name="state"
                    />
                </Cell>
                <Cell column={{ phone: 'span 2', laptop: 'span 1' }}>
                    <Text
                        value={user.postcode}
                        type="tel"
                        label="ZIP"
                        name="postcode"
                        rules={{
                            required: true,
                            minlength: 5
                        }}
                    />
                </Cell>
                <Cell column={columns}>
                    <Select
                        value={user.country}
                        options={[{
                            label: 'United States',
                            value: 'US',
                        }, {
                            label: 'Canada',
                            value: 'CA',
                        }]}
                        label="Country"
                        name="country"
                        rules={{ required: true, minlength: 2 }}
                    />
                </Cell>
            </Grid>
            {children}
        </ValidationForm>
    )
};

export default UserContact;